import loadable from '@loadable/component'

export default [
  {
    path: '/TreasureBox/choose',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureBox-choose" */ '~/pages/TreasureBox/pages/choose'
        )
    ),
  },
  {
    path: '/TreasureBox/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureBox-record" */ '~/pages/TreasureBox/pages/record'
        )
    ),
  },
  {
    path: '/TreasureBox',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureBox-list" */ '~/pages/TreasureBox/pages/list'
        )
    ),
  },
]
